<div>
    <div class="close-row">
        <app-dialog-close-button class="close-button" [size]="30" color="black" (closed)="close()"></app-dialog-close-button>
    </div>

    <div>
        <h2 class="share-text">Shared With</h2>

        <form [formGroup]="form" (ngSubmit)="submitForm()">
            <!-- V4-05: `align-items: flex-start`, not `center`. The Share button
                 keeps a 20px bottom margin (the gap to the list below), which
                 makes this flex line taller than the email field — so `center`
                 also pushed the FIELD down inside the line, and the button could
                 not be aligned to the field's control box by any offset of its
                 own. Both items now start at the row's top and
                 `.share-btn`'s margin-top drops the button onto the control box
                 (see share-history.component.scss). -->
            <div style="display: flex; justify-content: flex-start; align-items: flex-start">
                <vng-input
                    label="Enter email address"
                    placeholder="Enter email address"
                    type="email"
                    style="width: 265px;"
                    [formControl]="form.controls['email']"
                    [flyMsgIgnore]="true"
                    [error]="
                        (form.controls['email'].dirty || form.controls['email'].touched) ? (
                          form.controls['email'].hasError('required') ? 'Email is required.' :
                          (form.controls['email'].hasError('email') || form.controls['email'].hasError('pattern')) ? 'Please enter a valid email address' : ''
                        ) : ''
                    "
                ></vng-input>
                <button type="submit" [disabled]="submitted" vng-button variant="primary" class="share-btn">Share</button>
            </div>
        </form>

        <!-- Guide-sanctioned: mat-list -> plain ul/li + CSS (no vng list component). -->
        <ul class="share-history-list" style="overflow: auto; max-height: 290px;">
            <li *ngFor="let user of history">
                <div style="display: flex; justify-content: space-between; align-items: center; flex: 1 1 100%; max-width: 100%">
                    <div style="display: flex; flex: 1 1 100%; max-width: 54%">
                        <!-- V3-02: the `margin-left: -16px` these two carried existed only to
                             cancel mat-list-item's own 16px horizontal padding. The plain <li>
                             that replaced it has no left padding, so the negative margin pushed
                             the avatar 16px outside the `overflow: auto` <ul> and 16 of its 35px
                             were clipped away — a 19px sliver with the name butting against the
                             cut. Dropped: the avatar now starts at the list's content edge, the
                             same place master drew it. -->
                        <vng-icon name="person" [outline]="false" *ngIf="!user.profile_picture" class="share-history-list__avatar"></vng-icon>
                        <div class="profile-img share-history-list__avatar" *ngIf="user.profile_picture">
                            <img [src]="user.profile_picture" alt="" />
                        </div>
                        <div class="share-history-list__title" style="overflow: hidden; text-overflow: ellipsis; padding-left: 3px; width: 165px;" vngTooltip="{{user.name ?? user.email}}" vngTooltipPosition="top">{{user.name ?? user.email}}</div>
                    </div>
                    <div style="display: flex; justify-content: flex-start; align-items: center; flex: 1 1 100%; max-width: 46%">
                        <button
                            [vngTooltip]="user.resent ? 'You can resend after 30 minutes' : ''" vngTooltipPosition="top"
                            style="margin-right: 5px; width: 78px;"
                            [ngStyle]="{'visibility': user.status === FLYSHARE_INVITE_STATUS_PENDING ? 'visible' : 'hidden'}"
                            [disabled]="user.resent"
                            (click)="resend(user)"
                            vng-button variant="primary">
                        Resend
                        </button>
                        <div class="circle" [ngClass]="user.status === FLYSHARE_INVITE_STATUS_PENDING ? 'blur' : 'accent'"></div>
                        <span style="text-transform: capitalize;">{{user.status}}</span>
                    </div>
                </div>
            </li>
        </ul>

        <vng-divider></vng-divider>

        <div class="tooltip" *ngIf="linkCopied">
            <span class="tooltiptext">Link copied!</span>
        </div>
        <div class="copy-link" style="display: flex" (click)="copy()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2864 8.71403C10.6038 8.03173 9.67822 7.64844 8.7131 7.64844C7.74797 7.64844 6.82235 8.03173 6.13976 8.71403L3.56559 11.2874C2.88299 11.97 2.49951 12.8958 2.49951 13.8611C2.49951 14.8265 2.88299 15.7523 3.56559 16.4349C4.24819 17.1175 5.174 17.501 6.13934 17.501C7.10469 17.501 8.03049 17.1175 8.7131 16.4349L9.99976 15.1482" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.71289 11.2869C9.39548 11.9692 10.3211 12.3525 11.2862 12.3525C12.2513 12.3525 13.177 11.9692 13.8596 11.2869L16.4337 8.71358C17.1163 8.03098 17.4998 7.10518 17.4998 6.13983C17.4998 5.17449 17.1163 4.24868 16.4337 3.56608C15.7511 2.88348 14.8253 2.5 13.86 2.5C12.8946 2.5 11.9688 2.88348 11.2862 3.56608L9.99956 4.85275" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>&nbsp; Copy Link</span>
        </div>
    </div>
</div>
